import { type GrapeAPIErrorType } from 'components/hooks/GrapeAPIError'

import { Banner } from '../reusable/Banner'

export const GettingQuoteFailed = ({
  errorObj,
}: {
  errorObj: GrapeAPIErrorType;
}) => {
  return (
    <Banner type='critical' titleText='Problem getting quote'>
      <p className='mb-4'>
        There was a problem getting this quote. Error message:{' '}
        {errorObj.message}
      </p>
      {errorObj.errors && (
        <ul>
          {errorObj.errors.map((errorMsg, index) => (
            <li key={`api-error-${index}`}>{errorMsg}</li>
          ))}
        </ul>
      )}
    </Banner>
  )
}

export const CreateQuoteFailed = ({
  className,
  errorObj,
}: {
  className?: string,
  errorObj: GrapeAPIErrorType
}) => {
  return (
    <Banner className={className} type='critical' titleText='Problem creating quote'>
      <p className='mb-4'>
        There was a problem starting the quote creation process. Error message:{' '}
        {errorObj.message}
      </p>
      {errorObj.errors && (
        <ul>
          {errorObj.errors.map((errorMsg, index) => (
            <li key={`api-error-${index}`}>{errorMsg}</li>
          ))}
        </ul>
      )}
    </Banner>
  )
}

export const GettingProspectFailed = ({
  errorObj,
}: {
  errorObj: GrapeAPIErrorType;
}) => {
  return (
    <Banner type='critical' titleText='Problem getting prospect'>
      <p className='mb-4'>
        There was a problem getting this prospect. Error message:{' '}
        {errorObj.message}
      </p>
      {errorObj.errors && (
        <ul>
          {errorObj.errors.map((errorMsg, index) => (
            <li key={`api-error-${index}`}>{errorMsg}</li>
          ))}
        </ul>
      )}
    </Banner>
  )
}

export const GettingCensusFailed = ({
  errorObj,
}: {
  errorObj: GrapeAPIErrorType;
}) => {
  return (
    <Banner type='critical' titleText='Problem getting census'>
      <p className='mb-4'>
        There was a problem getting this census. Error message:{' '}
        {errorObj.message}
      </p>
      {errorObj.errors && (
        <ul>
          {errorObj.errors.map((errorMsg, index) => (
            <li key={`api-error-${index}`}>{errorMsg}</li>
          ))}
        </ul>
      )}
    </Banner>
  )
}

export const GettingBenchmarksFailed = ({
  errorObj,
}: {
  errorObj: GrapeAPIErrorType;
}) => {
  return (
    <Banner type='critical' titleText='Problem getting benchmarks'>
      <p className='mb-4'>
        There was a problem getting benchmarks. Error message:{' '}
        {errorObj.message}
      </p>
      {errorObj.errors && (
        <ul>
          {errorObj.errors.map((errorMsg, index) => (
            <li key={`api-error-${index}`}>{errorMsg}</li>
          ))}
        </ul>
      )}
    </Banner>
  )
}
